export default __webpack_public_path__ + "static/1213-2db18a7af14a08723972bae54548bda4.gif";